import Parse from 'parse';
import { InjectionToken, Provider } from '@angular/core';

import { ListMethodTypeLabelColorsQuery } from '@protocols/use-cases';
import { LabelConfigRepository } from '@telespot/domain';
import { ParseLabelConfigRepository } from '@telespot/infrastructure/parse';

import {
  LIST_METHOD_TYPE_LABEL_COLORS_QUERY,
  PipelineCategoryEffects,
} from '../../../effects/pipeline-category.effects';
import { PipelineCategoryState } from '../../../state/pipeline-category.state';

import { PipelineCategoryEditorFacade } from './pipeline-category-editor.facade';

const CATEGORY_EDITOR_LABEL_CONFIG_REPOSITORY = new InjectionToken<LabelConfigRepository>(
  'CATEGORY_EDITOR_LABEL_CONFIG_REPOSITORY'
);

export const pipelineCategoryEditorProviders: Provider[] = [
  PipelineCategoryState,
  PipelineCategoryEffects,
  PipelineCategoryEditorFacade,
  {
    provide: CATEGORY_EDITOR_LABEL_CONFIG_REPOSITORY,
    useFactory: () => new ParseLabelConfigRepository(Parse, { useMasterKey: false }),
  },
  {
    provide: LIST_METHOD_TYPE_LABEL_COLORS_QUERY,
    useFactory: (labelConfigRepository: LabelConfigRepository) =>
      new ListMethodTypeLabelColorsQuery(labelConfigRepository),
    deps: [CATEGORY_EDITOR_LABEL_CONFIG_REPOSITORY],
  },
];
